import React from "react";
import { useSiteData } from "../../Contexts/SiteContext";
import { Helmet } from "react-helmet-async";

const DynamicMetatag = () => {
  const { metaInfo, setMetaInfo } = useSiteData();
  const fakeDescription =
    "Thanoseshop is a safe & trusted Gaming currency and online Subcription selling site";
  const fakeTitle = "Thanos Gaming Shop";
  const fakeKeywords = "PUBG, Game, Subscription, Gift Card";

  return (
    <Helmet>
      <title>{metaInfo.title || fakeTitle}</title>
      <meta
        name="description"
        content={metaInfo.description || fakeDescription}
      />
      <meta name="keywords" content={fakeKeywords} />
    </Helmet>
  );
};

export default DynamicMetatag;
